import styled from 'styled-components';


export const PaginationWrapper = styled.div`
.pagination {
    justify-content: center;
    margin-top: 0;
    gap: 10px;
    background: transparent;
    padding-bottom: 50px;
    margin-bottom: 0;
    padding-top: 0px;
    .ellipsis{
        .page-link{
            background: transparent;
        }
        span{
            font-size: 24px;
        }
    }
    .prev-view{
        span{
            transform: rotate(87deg);
          
        }
    } 
    .next-view{
        span{
            transform: rotate(-87deg);
        }
    }
    .page-item{
        display: flex;
         &:hover,&.active{ 
            .page-link{
                background: #01606F;
                color: #fff;
                &:hover{
                    img{
                        filter: invert(100%) brightness(200%);
                    }
                  } 
                span{
                    &:hover{
                        img{
                            filter: invert(100%) brightness(145%);
                        }
                      } 
                }
            }
         }
    }
  .page-link {
        color: #000000;
        font-size: 14px;
        line-height: 13px;
        font-family: "Jost", sans-serif;
        font-weight: 500;
        border: none;
        background: rgb(33 130 136 / 10%) 0% 0% no-repeat padding-box;
        border-radius: 10px;
        width: 60px;
        min-width: 60px;
        height: 50px;
        display: inline-flex;
        justify-content: center;
        padding:0;
        align-items: center;
        overflow: hidden;
          text-align: center;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      &:focus{
        box-shadow: none;
      }  
         @media screen and (max-width:991px){
            width: 40px;
            min-width: 40px;
            height: 40px;
         }
       @media screen and (max-width:991px){
          width: 31px;
            min-width:31px;
            height: 31px;
    } 
    
  } 
}

`;